// WMM CRM v4 — mobile-nav.js
// Wires iPhone shell: hamburger drawer, bottom tab bar, David bottom sheet.
// CSS at style.css @media (max-width: 640px) handles all layout. This file
// handles state toggling and tab-bar active-state sync only.

export function initMobileNav() {
  const hamburger = document.getElementById('mobile-hamburger');
  const scrim     = document.getElementById('mobile-scrim');
  const tabbar    = document.getElementById('mobile-tabbar');
  const davidFab  = document.getElementById('david-fab');
  const mainNav   = document.getElementById('main-nav');

  // Hamburger → toggle drawer
  hamburger?.addEventListener('click', () => {
    document.body.classList.toggle('mobile-menu-open');
    document.body.classList.remove('david-sheet-open');
  });

  // Scrim → close whichever overlay is open
  scrim?.addEventListener('click', () => {
    document.body.classList.remove('mobile-menu-open', 'david-sheet-open');
  });

  // David FAB → toggle bottom sheet
  davidFab?.addEventListener('click', () => {
    document.body.classList.toggle('david-sheet-open');
    document.body.classList.remove('mobile-menu-open');
  });

  // Tab bar navigate buttons
  tabbar?.querySelectorAll('[data-view]').forEach(btn => {
    btn.addEventListener('click', () => window.showView?.(btn.dataset.view));
  });

  // "More" tab → open full nav drawer
  document.getElementById('mobile-tab-more')?.addEventListener('click', () => {
    document.body.classList.toggle('mobile-menu-open');
    document.body.classList.remove('david-sheet-open');
  });

  // Close drawer whenever a nav button inside it is tapped
  mainNav?.querySelectorAll('.nav-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.body.classList.remove('mobile-menu-open');
    });
  });

  // Sync tab bar active state by watching the sidebar nav for class changes.
  // app-legacy.js sets .active on .nav-btn when showView() runs; we mirror it.
  function syncTabActive(viewName) {
    tabbar?.querySelectorAll('[data-view]').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.view === viewName);
    });
  }

  if (mainNav) {
    new MutationObserver(() => {
      const active = mainNav.querySelector('.nav-btn.active[data-view]');
      if (active) syncTabActive(active.dataset.view);
    }).observe(mainNav, { attributes: true, subtree: true, attributeFilter: ['class'] });

    const initial = mainNav.querySelector('.nav-btn.active[data-view]');
    if (initial) syncTabActive(initial.dataset.view);
  }
}
